import {IGenericBooster} from "../types/booster_generic/IGenericBooster";
import {IBoosterTextSegmentType} from "../types/IBoosterTextSegmentType";

export const renderBoosterToString = <TParams extends object = never>(booster: IGenericBooster<TParams>, params?: TParams) => {
    const segments = booster.getSegments(params as TParams);

    if (!segments || segments.length === 0) {
        return null;
    }

    return segments
        .map((segment) => {
            if (typeof segment === "object") {
                switch (segment.type) {
                    case IBoosterTextSegmentType.HIGHLIGHTED:
                        return segment.text;
                    case IBoosterTextSegmentType.BUTTON:
                        return `- ${segment.text}`;
                    default:
                        return null;
                }
            }

            return segment;
        })
        .filter(Boolean)
        .join(" ");
};
import {IGenericBooster} from "../types/booster_generic/IGenericBooster";
import {IBoosterTextSegmentType} from "../types/IBoosterTextSegmentType";

export const renderBoosterToString = <TParams extends object = never>(booster: IGenericBooster<TParams>, params?: TParams) => {
    const segments = booster.getSegments(params as TParams);

    if (!segments || segments.length === 0) {
        return null;
    }

    return segments
        .map((segment) => {
            if (typeof segment === "object") {
                switch (segment.type) {
                    case IBoosterTextSegmentType.HIGHLIGHTED:
                        return segment.text;
                    case IBoosterTextSegmentType.BUTTON:
                        return `- ${segment.text}`;
                    default:
                        return null;
                }
            }

            return segment;
        })
        .filter(Boolean)
        .join(" ");
};
